var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChild({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50078 4.13793L8.57664 6.45517L11.2249 6.12414L9.56975 8.27586L11.1422 10.3448L8.49388 10.0138L7.50078 12.4138L6.42492 10.0965L3.77664 10.4276L5.43182 8.27586L3.8594 6.2069L6.50768 6.53793L7.50078 4.13793ZM7.50078 0L5.43182 4.71724L0.300781 4.13793L3.36285 8.27586L0.38354 12.4138L5.51457 11.8345L7.50078 16.5517L9.56975 11.8345L14.7008 12.331L11.6387 8.27586L14.618 4.13793L9.48699 4.71724L7.50078 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.ab98cd41c984c0a7981e9021afd91c5e.svg";
export { ForwardRef as ReactComponent };